import { axiosInstance } from "../../Utils/AxiosInstance";
import { handleApiError } from "../../Utils/handleApiError";

export const AddPublicLeadsApi = async (data, type) => {
  let snackBarData = {};
  try {
    let response = await axiosInstance.post(
      type === "RealState" ? "/PublicLeads/AddPublicLeadUnit" : "/PublicLeads/AddPublicLead",
      data
    );

    snackBarData = {
      type: response?.data.IsSuccess ? "success" : "error",
      message: response.data.Message,
      openToast: true,
    };

    return { ...response, snackBarData };
  } catch (error) {
    // snackBarData = {
    //   type: "error",
    //   message: error?.response.data.Message,
    //   openToast: true,
    // };
    const snackBarData = handleApiError(error);
    return { ...error?.response, snackBarData };
  }
};

export const AddWebsitePublicLeadsApi = async (data, BusinessId) => {
  let snackBarData = {};
  try {
    let response = await axiosInstance.post(`/PublicLeads/AddwebsitePublicLeadUnit?BusinessId=${BusinessId}`, data);

    snackBarData = {
      type: response?.data.IsSuccess ? "success" : "error",
      message: response.data.Message,
      openToast: true,
    };

    return { ...response, snackBarData };
  } catch (error) {
    // snackBarData = {
    //   type: "error",
    //   message: error?.response.data.Message,
    //   openToast: true,
    // };
    const snackBarData = handleApiError(error);
    return { ...error?.response, snackBarData };
  }
};
